/**
 *  Management of Application State
 */
import { createStore } from 'vuex'
import MyColors from "@/plugins/MyColors"


export default createStore({

  state: {
    // colors
    stdColorLight: MyColors.stdColorLight,
    stdColorDark: MyColors.stdColorDark,
    colorSystemBarOn: MyColors.colorSystemBarOn,
    colorSystemBarOff: MyColors.colorSystemBarOff,

    // selected language
    selectedLanguage: null,

    // router views in App
    routerViewToolbar: 'appToolbar',
    routerViewContent: 'appContent',

    //artikel
    sdbArtikel: [],

    // Language/Country combinations for SDB selection
    sdbLanguageCountrys: [],

    // List of sdb depending on selection
    sdbList: [],

    // states of selection
    isArtikel: true,
    selectionValue: null,

    //REST API
    sdblocaleByArtNr: 'sdb/sdblocale/artnr/',
    sdblocaleByText: 'sdb/sdblocale/text/',
    sdbByArtNr: 'sdb/sdb/artnr/',
    sdbByText: 'sdb/sdb/text/',
    sdbPdf: 'sdb/sdb/pdf',
    sdbProductImage: 'sdb/sdb/productimage/',
    artikelByArtNr: 'sdb/artikel/artnr/',
    artikelByText: 'sdb/artikel/text/',
    createMessageLogEntry: 'logcentral',
    getLogInfo: 'logcentral/loginfo'
  },

  mutations: {
    SET_SELECTEDLANGUAGE(state, selectedLanguage) {
      state.selectedLanguage = selectedLanguage
    },

    SET_ROUTERVIEW_TOOLBAR(state, routerViewToolbar) {
      state.routerViewToolbar = routerViewToolbar
    },

    SET_ROUTERVIEW_CONTENT(state, routerViewContent) {
      state.routerViewContent = routerViewContent
    },

    SET_SDB_ARTIKEL(state, sdbArtikel) {
      state.sdbArtikel = sdbArtikel
    },

    SET_SDB_LANGUAGECOUNTRYS(state, sdbLanguageCountrys) {
      state.sdbLanguageCountrys = sdbLanguageCountrys
    },

    SET_SDB_LIST(state, sdbList) {
      state.sdbList = sdbList
    },

    SET_IS_ARTIKEL(state, isArtikel) {
      state.isArtikel = isArtikel
    },

    SET_SELECTION_VALUE(state, selectionValue) {
      state.selectionValue = selectionValue
    }

  },

  actions: {
    setSelectedLanguage(context, selectedLanguage) {
      context.commit("SET_SELECTEDLANGUAGE", selectedLanguage)
    },

    setRouterViewToolbar(context, routerViewToolbar) {
      context.commit("SET_ROUTERVIEW_TOOLBAR", routerViewToolbar)
    },

    setRouterViewContent(context, routerViewContent) {
      context.commit("SET_ROUTERVIEW_CONTENT", routerViewContent)
    },

    setSdbArtikel(context, sdbArtikel) {
      context.commit("SET_SDB_ARTIKEL", sdbArtikel)
    },

    setSdbLanguageCountrys(context, sdbLanguageCountrys) {
      context.commit("SET_SDB_LANGUAGECOUNTRYS", sdbLanguageCountrys)
    },

    setSdbList(context, sdbList) {
      context.commit("SET_SDB_LIST", sdbList)
    },

    setIsArtikel(context, isArtikel) {
      context.commit("SET_IS_ARTIKEL", isArtikel)
    },

    setSelectionValue(context, selectionValue) {
      context.commit("SET_SELECTION_VALUE", selectionValue)
    }

  },

  getters: {
    // get selected language
    selectedLanguage: state => state.selectedLanguage,

    // get state of routerViewToolbar
    routerViewToolbar: state => state.routerViewToolbar,

    // get state of routerViewContent
    routerViewContent: state => state.routerViewContent,

    // get artikel array
    sdbArtikel: state => state.sdbArtikel,

    // get sdb array of language/country combinations
    sdbLanguageCountrys: state => state.sdbLanguageCountrys,

    // get list of sdb depending on selection
    sdbList: state => state.sdbList,

    isArtikel: state => state.isArtikel,
    selectionValue: state => state.selectionValue,

    sdbLanguageCountryEntrys: state => {
      if (state.sdbLanguageCountrys.length>0)
        return state.sdbLanguageCountrys.map(sdbLanguageCountry => sdbLanguageCountry.displayCountry+":"+sdbLanguageCountry.displayLanguage)
      else
        return []
    },    

    // getters for sdb REST API
    sdblocaleByArtNr: state => state.sdblocaleByArtNr,
    sdblocaleByText: state => state.sdblocaleByText,
    sdbByArtNr: state => state.sdbByArtNr,
    sdbByText: state => state.sdbByText,
    sdbPdf: state => state.sdbPdf,
    sdbProductImage: state => state.sdbProductImage,
    artikelByArtNr: state => state.artikelByArtNr,
    artikelByText: state => state.artikelByText,
    createMessageLogEntry: state => state.createMessageLogEntry,
    getLogInfo: state => state.getLogInfo,

    //getters for colors:
    stdColorLight: state => state.stdColorLight,
    stdColorDark: state => state.stdColorDark,
    colorSystemBarOn: state => state.colorSystemBarOn,
    colorSystemBarOff: state => state.colorSystemBarOff
  }
})
